import React from "react";
import {Link} from "react-router-dom";

export function ticketAuditId(row) {
	if (!row) {
		return null;
	}
	if (row.ticket_pkey) {
		return row.ticket_pkey;
	}
	const ticket = row.ticket != null ? row.ticket : row.Ticket;
	if (ticket != null && typeof ticket === "object") {
		return ticket.pkey ?? ticket.Pkey ?? null;
	}
	if (ticket != null) {
		return ticket;
	}
	return null;
}

export function ticketRowReviewed(row) {
	if (!row) {
		return false;
	}
	return Number(row.auditReviewed) === 1;
}

export function ticketIsClosed(row) {
	if (!row) {
		return false;
	}
	const closed = row.ticket_closed ?? row.TicketClosed ?? row.closed ?? row.Closed;
	return closed != null && closed !== "" && closed !== "0000-00-00 00:00:00";
}

export default function TicketAuditReviewLink({row}) {
	const ticketId = ticketAuditId(row);
	if (!ticketId) {
		return null;
	}
	const reviewed = ticketRowReviewed(row);
	if (!ticketIsClosed(row)) {
		return (
			<div style={{textAlign: "center", color: "#9e9e9e"}} title="Available after the ticket is closed">
				Review
			</div>
		);
	}
	return (
		<div style={{textAlign: "center"}}>
			<Link to={"/helpdesks/audit/" + ticketId}>
				{reviewed ? "View audit" : "Review"}
			</Link>
		</div>
	);
}
